import classNames from "classnames";
import { DComponent } from "../../../../../../components/DComponent";
import Env from "../../../../../../environments";
import { PAYMENT_PROVIDER } from "../../../../../../utils/payment";
import { LocalStorage } from "../../../../../../models/LocalStorage";
import { MINI_APP } from "../../../../../../utils/miniApp";
import { devLog } from "../../../../../../utils/log";
import { isFeatureActive } from "../../../../../../utils/feature";
import { LIST_QUERYSTRING } from "../../../../../../utils/constant";

export default class StripeGoogleApple extends DComponent {
  constructor({
    parent,
    id,
    paymentRequestData,
    merchantCountry,
    chargeSecret,
    onConfirmSuccess = () => { },
    onConfirmError = () => { },
    onCancel = () => { },
    onHide = () => { },
    updateChargeSecret = () => { },
    type = "",
    title = "",
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("StripeGoogleApple"),
      title: title,
      type: type,
    }, true);
    this.chargeSecret = chargeSecret;
    this.onConfirmSuccess = onConfirmSuccess;
    this.onConfirmError = onConfirmError;
    this.onCancel = onCancel;
    this.onHide = onHide;
    this.updateChargeSecret = updateChargeSecret;
    this.stripe = undefined;
    this.paymentRequest = undefined;
    this.paymentRequestData = paymentRequestData;
    this.merchantCountry = merchantCountry;
    this.type = type;
    this.render();
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.setupStripe();
  }

  setupStripe() {
    try {
      // eslint-disable-next-line no-undef
      this.stripe = Stripe(Env.DUTY_CAST_STRIPE_API_KEY, {
        apiVersion: "2020-08-27",
      });
    } catch (error) {
      typeof this.onHide === "function" && this.onHide();
      devLog(error);
    }
  }

  setUpEvent(paymentRequest) {
    paymentRequest.on('paymentmethod', (event) => {
      typeof this.updateChargeSecret === "function" && this.updateChargeSecret();
      this.handleConfirmStripe(event);
    });
    paymentRequest.on('cancel', () => {
      // handle cancel event
      typeof this.onCancel === "function" && this.onCancel();
    });
  }

  async checkValid() {
    let testFeature = this.type === PAYMENT_PROVIDER.STRIPE_APPLE ? isFeatureActive(LIST_QUERYSTRING.CHECKOUT.STRIPE_APPLE) : isFeatureActive(LIST_QUERYSTRING.CHECKOUT.STRIPE_GOOGLE);

    if (!testFeature) {
      let acceptList = Env.DUTY_CAST_ACCEPT_PAYMENT_METHOD || [];
      if (!acceptList.includes(this.type)) {
        return false;
      }
    }

    try {
      if (LocalStorage.isMiniApp()) {
        return this.type === PAYMENT_PROVIDER.STRIPE_APPLE ? MINI_APP.getReturnData("checkApplePaySupport") : MINI_APP.getReturnData("checkGooglePaySupport");
      }

      if (!this.paymentRequest) {
        this.paymentRequest = this.stripe.paymentRequest(this.paymentRequestData);
      } else {
        this.paymentRequest.update({
          country: this.paymentRequestData.country,
          currency: this.paymentRequestData.currency,
          total: this.paymentRequestData.total,
        })
      }

      const result = await this.paymentRequest.canMakePayment();

      let hasGoogleApple = (this.type === PAYMENT_PROVIDER.STRIPE_APPLE && result?.applePay) || (this.type === PAYMENT_PROVIDER.STRIPE_GOOGLE && result?.googlePay);

      if (hasGoogleApple && !this.mouted) {
        this.setUpEvent(this.paymentRequest);
        this.mouted = true;
      }

      return hasGoogleApple;
    } catch (error) {
      devLog(error);
      return false;
    }
  }

  async handleConfirmStripe(event) {
    if (!this.chargeSecret) {
      typeof this.onConfirmError === "function" && this.onConfirmError();
      this.hide();
      return;
    }
    const { paymentIntent, error: confirmError } = await this.stripe.confirmCardPayment(
      this.chargeSecret,
      { payment_method: event.paymentMethod.id },
      { handleActions: false }
    );

    if (confirmError) {
      // Report to the browser that the payment failed, prompting it to
      // re-show the payment interface, or show an error message and close
      // the payment interface.
      event.complete('fail');
      devLog("confirmError:", confirmError)
      typeof this.onConfirmError === "function" && this.onConfirmError(confirmError);
    } else {
      // Report to the browser that the confirmation was successful, prompting
      // it to close the browser payment method collection interface.
      event.complete('success');
      // Check if the PaymentIntent requires any actions and, if so, let Stripe.js
      // handle the flow. If using an API version older than "2019-02-11"
      // instead check for: `paymentIntent.status === "requires_source_action"`.
      if (paymentIntent.status === "requires_action") {
        // Let Stripe.js handle the rest of the payment flow.
        const { error } = await this.stripe.confirmCardPayment(this.chargeSecret);
        if (error) {
          // The payment failed -- ask your customer for a new payment method.
          typeof this.onConfirmError === "function" && this.onConfirmError(error);
        } else {
          // The payment has succeeded -- show a success message to your customer.
          typeof this.onConfirmSuccess === "function" && this.onConfirmSuccess(paymentIntent?.id);
        }
      } else {
        // The payment has succeeded -- show a success message to your customer.
        typeof this.onConfirmSuccess === "function" && this.onConfirmSuccess(paymentIntent?.id);
      }
    }
  }

  requestPayment() {
    if (LocalStorage.isMiniApp()) {
      let params = {
        chargeSecret: this.chargeSecret,
        merchantCountryCode: this.merchantCountry,
        country: this.paymentRequestData.country,
        currency: this.paymentRequestData.currency,
        label: this.paymentRequestData.total?.label,
        amount: this.paymentRequestData.total?.amount,
      }
      if (this.type === PAYMENT_PROVIDER.STRIPE_APPLE) {
        MINI_APP.getReturnData("requestApplePay", params).then(data => this.handleResponseRequest(data));
      } else {
        MINI_APP.getReturnData("requestGooglePay", params).then(data => this.handleResponseRequest(data));;
      }
      return;
    }
    try {
      this.paymentRequest.show();
    } catch (error) {
      typeof this.onConfirmError === "function" && this.onConfirmError(error);
    }
  }

  handleResponseRequest({ status, errorCode, message }) {
    if (status === "failed") {
      if (errorCode === "Completed") {
        typeof this.onConfirmSuccess === "function" && this.onConfirmSuccess();
      } else if (errorCode === "Canceled") {
        typeof this.onCancel === "function" && this.onCancel();
      } else {
        typeof this.onConfirmError === "function" && this.onConfirmError(message);
      }
    } else {
      typeof this.onConfirmSuccess === "function" && this.onConfirmSuccess();
    }
  }

  /** @param {StripeGoogleApple} _data - The text to repeat */
  updateAttributes(_data) {
    Object.keys(_data).forEach(key => {
      this[key] = _data[key];
    });
  }
}